class TeamRequestDataService {
  constructor() {}

  setData(data) {
    this._data = data;
  }

  getData() {
    return this._data;
  }

  clean() {
    this._data = undefined;
  }

  isEmpty() {
    return this._data === undefined;
  }
}

export default TeamRequestDataService;


// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/services/teamRequestData.service.js